import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUserPointsBalance } from '@/shared/model/user-points-balance.model';

const baseApiUrl = 'api/user-points-balances';
const baseSearchApiUrl = 'api/_search/user-points-balances?query=';

export default class UserPointsBalanceService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUserPointsBalance> {
    return new Promise<IUserPointsBalance>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUserPointsBalance): Promise<IUserPointsBalance> {
    return new Promise<IUserPointsBalance>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUserPointsBalance): Promise<IUserPointsBalance> {
    return new Promise<IUserPointsBalance>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
